import { EMPTY_RICH_TEXT_CONTENT } from './constants';
import { RichTextEditor } from './RichTextEditor';

export { EMPTY_RICH_TEXT_CONTENT };
export default RichTextEditor;
